// nosemgrep: dont_use_react_native_hooks
import { useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useApolloClient } from '@apollo/client'

// nosemgrep: typescript.factorial-frontend.design-system-outside-dependencies
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
// nosemgrep: typescript.factorial-frontend.design-system-outside-dependencies
import { useNavigation } from 'modules/core/hooks/useNavigation'
// nosemgrep: typescript.factorial-frontend.design-system-outside-dependencies
import { MetaContext as MetaContextType } from 'modules/core/lib/navigation/routes'

export function useMetaContext() {
  const apolloClient = useApolloClient()
  const { navigation } = useNavigation()
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const session = useCurrentSession()
  const context = useMemo<MetaContextType>(
    () => ({
      watchQuery: (...[options, ...rest]) =>
        apolloClient?.watchQuery(
          {
            fetchPolicy: 'cache-first',
            ...options,
          },
          ...rest
        ),
      apolloClient: apolloClient,
      navigation,
      params,
      navigate,
      location,
      session,
    }),
    [apolloClient, navigation, params, location, navigate, session]
  )

  return { context }
}
